
/* injects from baggage-loader */

import moment from "moment";
import Config from "../../../config/main";

export const getSwarmSubscriptionRequestGameListAsian = (sportAlias, gameType, regionId, competitionId, timeFilter) => {
    // console.log(Config.asianViewMarket, "iijijijijijijijijijijijijijijij");

    const gameTypeA = gameType === 'live' ? gameType : 'prematch';
    const { default: { [gameTypeA]: defaultMarket = {} } = {} } = Config.asianViewMarket;
    const { [sportAlias]: { [gameTypeA]: market = defaultMarket } = {} } = Config.asianViewMarket;
    let marketDisplayKeys = [
        {
            "display_key": "OUTRIGHT"
        }
    ];
    sportAlias && market.forEach(element => {
        element.forEach(item => {
            // eslint-disable-next-line no-unused-vars
            const { title, side, base, ...rest } = item;
            if (base !== undefined && base !== 'all') {
                marketDisplayKeys.push({ ...rest, base });
            } else {
                marketDisplayKeys.push(rest);
            }
        });
    });
    const where = {
        "game": {
            "@or": [
                { "type": { "@in": [0, 2] } },
                { "visible_in_prematch": 1 }
            ]
        },
        "sport": {
            "type": { "@in": [0, 2, 5] }
        }  
    };
    if (sportAlias !== 'all') {
        where.market = { "@or": marketDisplayKeys };
    }
    let request = {
        "source": "betting",
        "what": {
            "sport": ["id", "name", "alias", "order"],
            "competition": ["name", "order", "id", "teams_reversed"],
            "region": ["name", "alias", "id", "order"],
            "game": [["id", "team1_name", "team2_name", "team1_reg_name", "team2_reg_name", "team1_id", "team2_id", "info", "game_number", "start_ts", "type", "text_info", "events_count", "is_blocked", "markets_count", "stats", "strong_team", "is_neutral_venue", "is_stat_available", "tv_type", "video_id", "video_id2", "video_id3", "video_provider", "sportcast_id"]],
            "market": ["base", "id", "name", "order", "sequence", "show_type", "cashout", "display_key", "display_sub_key", "market_type", "home_score", "away_score", "main_order", "optimal", "col_count", "group_id", "express_id", "group_name"],
            "event": ["name", "id", "base", "type", "type_1", "price", "show_type"]
        },
        where
    };
    if (regionId && regionId !== "all") {
        if (regionId.constructor === Array && regionId.length > 1) {
            request.where.region = { id: { "@in": regionId } };
        }
        else if (isNaN(parseInt(regionId))) {
            request.where.region = { alias: regionId };
        } else {
            request.where.region = { id: regionId.constructor === Array ? regionId[0] : +regionId };
        }
    }

    if (competitionId) {
        request.where.competition = { id: competitionId };
    }
    if (gameType === "live") {
        request.where.game = { type: 1 };
    }
    if (sportAlias !== "all") {
        request.where.sport = {
            ...request.where.sport,
            "alias": sportAlias
        };
    }
    if (gameType === "topGames") {
        request.where.game = {
            "type": { "@in": [0, 2] },
            "promoted": true
        };
    }
    if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
        request.where.game = {
            "@or": [{ "type": { "@in": [0, 2] } }, { "visible_in_prematch": 1 }]
        };
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        request.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': oneDayDate,
                        '@lte': oneDayDate + 86400
                    },
                    "type": { "@in": [0, 2] }
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }
    if (timeFilter && !Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        const gte = Config.enableOneDayRangeFilterPrematch ? (timeFilter - 24) * 3600 : 0;

        request.where.game.start_ts = {
            '@now': {
                '@gte': Config.enableDayFormatInPrematchLeftMenu
                    ? moment().startOf("day").unix() + (timeFilter * 2)
                    : gte,
                '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            }
        };
    } else if (timeFilter && Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        var newDate = moment().startOf('day').unix() + timeFilter * 24 * 60 * 60;
        if (timeFilter === (-1)) {
            newDate = moment().startOf('day').unix() + 0 * 24 * 60 * 60;
        }
        request.where.game.start_ts = {
            '@gte': newDate,
            '@lt': newDate + 86400
        };
    }
    if (gameType === "today") {
        request.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": { "@in": [0, 2] }
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }

    return request;
};

export const getSwarmSubscriptionRequestGameMarketsCountAsian = (sportAlias, gameType, regionId, competitionId, timeFilter, gameIds) => {
    const where = {
        "game": {
            "@or": [
                { "type": { "@in": [0, 2] } },
                { "visible_in_prematch": 1 }
            ]
        }
    };

    if (gameIds) {
        where.game = {
            id: { '@in': gameIds }
        };
    }

    if (regionId) {
        if (regionId.constructor === Array && regionId.length > 1) {
            where.region = { id: { "@in": regionId } };
        } else {
            where.region = { id: regionId.constructor === Array ? regionId[0] : regionId };
        }
    }
    if (competitionId) {
        where.competition = { id: competitionId };
    }
    if (gameType === "live") {
        where.game = { type: 1 };
    }
    if (sportAlias) {
        where.sport = {
            "type": { "@in": [0, 2, 5] }
        };

        if (sportAlias !== "all") where.sport.alias = sportAlias;
    }
    if (gameType === "topGames") {
        where.game = {
            "type": { "@in": [0, 2] },
            "promoted": true
        };
    }
    if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
        where.game = {
            "@or": [{ "type": { "@in": [0, 2] } }, { "visible_in_prematch": 1 }]
        };
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        const oneDayDate = moment().unix();
        where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': oneDayDate,
                        '@lte': oneDayDate + 86400
                    },
                    "type": { "@in": [0, 2] }
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }
    if (timeFilter && !Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        where.game.start_ts = {
            '@now': {
                '@gte': Config.enableDayFormatInPrematchLeftMenu ? moment().startOf("day").unix() + (timeFilter * 2) : 0,
                '@lt': Config.enableDayFormatInPrematchLeftMenu ? moment().endOf("day").unix() + timeFilter : timeFilter * 3600
            }
        };
    } else if (timeFilter && Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        let newDate = moment().startOf('day').unix() + timeFilter * 24 * 60 * 60;
        if (timeFilter === (-1)) {
            newDate = moment().startOf('day').unix() + 0 * 24 * 60 * 60;
        }
        where.game.start_ts = {
            '@gte': newDate,
            '@lt': newDate + 86400
        };
    }
    if (gameType === "today") {
        where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": { "@in": [0, 2] }
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }

    const request = {
        "source": "betting",
        "what": {
            "market": "@count",
            "game": ["id"]
        },
        where
    };

    return request;
};